import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { toJS } from 'mobx';

import classNames from 'classnames';
import Iframe from 'react-iframe';
import { PDFObject } from 'react-pdfobject';

import ReactHtmlParser from 'react-html-parser';

import { Button, Confirm, Icon, Image } from 'semantic-ui-react';

import '../../css/FileViewerModal.less';

import { CONTENT_ITEM_TYPES, CONTENT_MODE } from '../../managers/ContentManager';

import Auth from '../../managers/AuthManager';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import ActivityInstanceUserNavigationService from '../../services/ActivityInstanceUserNavigationService';
import UtilityService from '../../services/UtilityService';

import { stripHtmlTags } from '../../utils/stripHtml';

import iconListen from '../../img/icon-listen.svg';

import Modal from '../Modal';

export default
@inject('assignmentManager', 'classroomManager', 'contentManager', 'gradebookManager', 'studentContentCardManager', 'userManager')
class FileViewerModal extends Component {
    received = false;

    constructor(props) {
      super(props);
      this.InfoModal = SatCoreComponent('InfoModal');
      this.ScoreAssignmentModal = SatCoreComponent('ScoreAssignmentModal');
      this.state = {
        addInfoOpen: false,
        confirmationOpen: false,
        contentUrl: null,
        currentAssignment: null,
        currentInstance: null,
        interval: null,
        isLoading: true,
        showScoreModal: false
      };
    }

    async componentDidMount() {
      const {
        assignmentId,
        assignmentManager,
        activityId,
        contentItemId,
        contentMode,
        gradebookManager,
        isFlowpaper,
        page,
        studentContentCardManager
      } = this.props;

      try {
        // Set flag to prevent Gradebook from showing loader when modal is open
        if (gradebookManager) {
          gradebookManager.setIsFileViewerOrDocReaderModalOpen(true);
        }

        // Initialize currentInstance for navigation if in gradebook context
        if (gradebookManager && gradebookManager.assignmentInstancesMap && assignmentId) {
          const currentInstance = ActivityInstanceUserNavigationService.getCurrentActivityInstanceForUser(
            gradebookManager.assignmentInstancesMap,
            assignmentId
          );
          this.setState({ currentInstance });
        }

        // Store initial assignment to use as fallback during navigation
        if (activityId) {
          const initialAssignment = await assignmentManager.getAssignmentAsync(activityId);
          if (initialAssignment) {
            this.setState({ currentAssignment: toJS(initialAssignment) });
          }
        }

        if (page && page === 'file-viewer') {
          window.addEventListener('message', this.handleIframeTask);
        }
        if (contentMode === CONTENT_MODE.ASSESS && !isFlowpaper) {
          const sessionStart = new Date();
          this.setState({
            interval:
          setInterval(async () => {
            const sessionPing = new Date();
            let viewedTime = (sessionPing - sessionStart) / 1000;
            viewedTime = viewedTime.toFixed(0);
            assignmentManager.markActivityViewed(activityId, contentItemId, viewedTime);
          }, 10000)
          });
        }

        if (studentContentCardManager.isLoading) {
          studentContentCardManager.setIsLoading(false);
        }
      } finally {
        // Ensure loading state is cleared even if initialization fails
        this.setState({ isLoading: false });
      }
    }

    async componentWillUnmount() {
      const { gradebookManager } = this.props;
      clearInterval(this.state.interval);
      window.removeEventListener('message', this.handleIframeTask);

      // Clear flag to allow Gradebook to show loader again
      if (gradebookManager) {
        gradebookManager.setIsFileViewerOrDocReaderModalOpen(false);
      }
    }

    handleOpenInfo = () => {
      this.setState({ addInfoOpen: true });
    }

    closeInfoModal = () => {
      this.setState({ addInfoOpen: false });
    }

    handleIframeTask = (e) => {
      if (e.origin === Auth.publisher && e.data === 'closePressed') {
        this.props.closeIframeCallback();
      }
    };

    openGradeAssignment = () => {
      this.setState({ showScoreModal: true });
    }

    closeGradeAssignment = () => {
      const { gradebookManager } = this.props;
      const { currentInstance } = this.state;

      // Refresh the currentInstance from the map to get updated score data
      if (currentInstance && gradebookManager.assignmentInstancesMap) {
        const updatedInstance = gradebookManager.assignmentInstancesMap.get(currentInstance.id);
        if (updatedInstance) {
          this.setState({
            currentInstance: toJS(updatedInstance),
            showScoreModal: false
          });
        } else {
          this.setState({ showScoreModal: false });
        }
      } else {
        this.setState({ showScoreModal: false });
      }

      this.refreshClassroomData();
    }

    refreshClassroomData = async () => {
      const { classroomManager, isFromLTI } = this.props;
      if (!isFromLTI) {
        await classroomManager.fetchClassroomData(classroomManager.currentClassroomId);
      }
    }

    allowRenderScoreButton = () => {
      const { contentMode, userManager } = this.props;
      return contentMode === CONTENT_MODE.REVIEW && userManager.canViewAsTeacher;
    }

    handlePreviousStudent = async () => {
      const { assignmentManager, contentManager, gradebookManager } = this.props;
      const { currentAssignment, currentInstance } = this.state;

      if (!gradebookManager.assignmentInstancesMap || !currentInstance) {
        return;
      }

      this.setState({ isLoading: true });

      try {
        const prevInstance = ActivityInstanceUserNavigationService.getPreviousActivityInstanceForUser(
          gradebookManager.assignmentInstancesMap,
          currentInstance.id
        );

        if (!prevInstance) {
          return;
        }

        // Get assignment for the new student
        const fetchedAssignment = await assignmentManager.getAssignmentAsync(prevInstance.activityId);

        // Ensure assignment has required fields, using fallback from current assignment if needed
        const assignment = {
          ...fetchedAssignment,
          contentItemEntityTypeId: fetchedAssignment.contentItemEntityTypeId || currentAssignment?.contentItemEntityTypeId,
          pdfDeliveryFormat: fetchedAssignment.pdfDeliveryFormat || currentAssignment?.pdfDeliveryFormat
        };

        // Set session ID FIRST to ensure it's available before iframe loads
        contentManager.setCurrentFlowPaperSessionId(prevInstance.id);

        // Use getOptionsForTeacherReviewAndScoring to fetch URL and set up content
        const options = await contentManager.getOptionsForTeacherReviewAndScoring(
          assignment,
          prevInstance,
          window.location.origin,
          true,
          assignment.courseResourceElementId,
          assignment.id
        );

        if (!options || !options.viewUrl) {
          throw new Error('Failed to get content options for previous student');
        }

        this.setState({
          contentUrl: options.viewUrl,
          currentAssignment: toJS(assignment),
          currentInstance: prevInstance
        });
      } finally {
        this.setState({ isLoading: false });
      }
    }

    handleNextStudent = async () => {
      const { assignmentManager, contentManager, gradebookManager } = this.props;
      const { currentAssignment, currentInstance } = this.state;

      if (!gradebookManager.assignmentInstancesMap || !currentInstance) {
        return;
      }

      this.setState({ isLoading: true });

      try {
        const nextInstance = ActivityInstanceUserNavigationService.getNextActivityInstanceForUser(
          gradebookManager.assignmentInstancesMap,
          currentInstance.id
        );

        if (!nextInstance) {
          return;
        }

        // Get assignment for the new student
        const fetchedAssignment = await assignmentManager.getAssignmentAsync(nextInstance.activityId);

        // Ensure assignment has required fields, using fallback from current assignment if needed
        const assignment = {
          ...fetchedAssignment,
          contentItemEntityTypeId: fetchedAssignment.contentItemEntityTypeId || currentAssignment?.contentItemEntityTypeId,
          pdfDeliveryFormat: fetchedAssignment.pdfDeliveryFormat || currentAssignment?.pdfDeliveryFormat
        };

        // Set session ID FIRST to ensure it's available before iframe loads
        contentManager.setCurrentFlowPaperSessionId(nextInstance.id);

        // Use getOptionsForTeacherReviewAndScoring to fetch URL and set up content
        const options = await contentManager.getOptionsForTeacherReviewAndScoring(
          assignment,
          nextInstance,
          window.location.origin,
          true,
          assignment.courseResourceElementId,
          assignment.id
        );

        if (!options || !options.viewUrl) {
          throw new Error('Failed to get content options for next student');
        }

        this.setState({
          contentUrl: options.viewUrl,
          currentAssignment: toJS(assignment),
          currentInstance: nextInstance
        });
      } finally {
        this.setState({ isLoading: false });
      }
    }

    handleOpenDocReader = async () => {
      const { contentManager } = this.props;
      await contentManager.fetchDocReaderUrl(contentManager.currentContentItemId);
      contentManager.openTabContent(contentManager.docReaderUrl);
    }

    submitAndClose = async () => {
      const { assignmentManager, userManager, assignmentId, contentMode } = this.props;
      if (!userManager.canViewAsTeacher || (userManager.canViewAsTeacher && contentMode === CONTENT_MODE.TEACHER_PRESENT)) {
        await assignmentManager.submitActivityInstance(assignmentId);
      }

      this.justClose();
    }

    justClose = async () => {
      const { contentType, closeModalCallback } = this.props;
      if (contentType === CONTENT_ITEM_TYPES.SCORM_RESOURCE) {
        const innerIframe = document.getElementById('myFrame').contentWindow;
        const message = {
          action: 'unload',
          newUrl: 'about:blank', // maybe point to a spinner asset here.
          origin: 'satellite'
        };

        innerIframe.postMessage(message, '*');

        setTimeout(() => {
          closeModalCallback();
        }, 2000);
      } else {
        closeModalCallback();
      }
    }

    startSubmit = async () => {
      this.setState({ confirmationOpen: true });
    }

    closeConfirmation = async () => {
      this.setState({ confirmationOpen: false });
    }

    renderSubmitButton = () => {
      const { userManager, contentMode, t } = this.props;
      if (!userManager.canViewAsTeacher && contentMode === CONTENT_MODE.ASSESS) {
        return (
          <Button className='file-viewer-submit-btn student' onClick={() => this.startSubmit()} primary>
            {t('submitButtonLabel')}
          </Button>
        );
      } else if (userManager.canViewAsTeacher && contentMode === CONTENT_MODE.TEACHER_PRESENT) {
        return (
          <Button className='file-viewer-save-btn student' onClick={() => this.justClose()} primary>
            {t('saveButtonLabel')}
          </Button>
        );
      }
      return null;
    }

    renderStudentInstructionButton = () => {
      const { instruction, userManager, contentMode, t } = this.props;
      if (instruction && instruction !== '<p></p>') {
        const isStudentView = !userManager.canViewAsTeacher
          || (userManager.canViewAsTeacher && contentMode === CONTENT_MODE.TEACHER_PRESENT);

        return (
          <Button
            className={classNames('file-viewer-student-instruction-btn', 'basic', 'white', {
              'student-instruction': isStudentView
            })}
            onClick={() => this.handleOpenInfo()}
            primary>
            {t('studentInstructionsButtonLabel')}
          </Button>
        );
      }
      return null;
    }

    renderPreviousStudentButton = () => {
      const { gradebookManager, isFromGradebook, t } = this.props;
      const allowScoring = this.allowRenderScoreButton();

      // Only show navigation when opened from gradebook
      if (!isFromGradebook) {
        return null;
      }

      if (!allowScoring || !gradebookManager.assignmentInstancesMap) {
        return null;
      }

      const enableNavigation = ActivityInstanceUserNavigationService.shouldEnableNavigation(
        gradebookManager.assignmentInstancesMap
      );

      if (!enableNavigation) {
        return null;
      }

      return (
        <Button
          className='file-viewer-prev-student-btn basic white'
          onClick={this.handlePreviousStudent}
          primary>
          <div className='file-viewer-prev-student-btn-content-inner-wrapper'>
            <div className='file-viewer-btn-nav-icon-wrapper prev-student-btn-icon-wrapper'>
              <Icon className='prev-student-nav-icon' name='angle up' size='large' />
            </div>
            <div className='file-viewer-btn-text prev-student-btn-text'>{t('previousStudent')}</div>
          </div>
        </Button>
      );
    }

    renderNextStudentButton = () => {
      const { gradebookManager, isFromGradebook, t } = this.props;
      const allowScoring = this.allowRenderScoreButton();

      // Only show navigation when opened from gradebook
      if (!isFromGradebook) {
        return null;
      }

      if (!allowScoring || !gradebookManager.assignmentInstancesMap) {
        return null;
      }

      const enableNavigation = ActivityInstanceUserNavigationService.shouldEnableNavigation(
        gradebookManager.assignmentInstancesMap
      );

      if (!enableNavigation) {
        return null;
      }

      return (
        <Button
          className='file-viewer-next-student-btn basic white'
          onClick={this.handleNextStudent}
          primary>
          <div className='file-viewer-next-student-btn-content-inner-wrapper'>
            <div className='file-viewer-btn-nav-icon-wrapper next-student-btn-icon-wrapper'>
              <Icon className='next-student-nav-icon' name='angle down' size='large' />
            </div>
            <div className='file-viewer-btn-text next-student-btn-text'>{t('nextStudent')}</div>
          </div>
        </Button>
      );
    }

    renderScoreButton = () => {
      const { t } = this.props;
      const allowScoring = this.allowRenderScoreButton();

      if (allowScoring) {
        return (
          <Button className='file-viewer-score-btn basic white' onClick={() => this.openGradeAssignment()} primary>
            {t('scoreButtonLabel')}
          </Button>
        );
      }
      return null;
    }

    renderDocReaderButton = () => {
      const { contentManager, userManager, contentMode } = this.props;
      if (this.props.isFlowpaper && contentManager.docReaderId !== '' && contentManager.docReaderId !== null && contentManager.docReaderId !== undefined) {
        return (
          <Button className={(!userManager.canViewAsTeacher || (userManager.canViewAsTeacher && contentMode === CONTENT_MODE.TEACHER_PRESENT)) ? 'basic student white' : 'basic white'} onClick={() => this.handleOpenDocReader()} primary>
            <Image alt='' className='space-right' src={iconListen} />
            {' '}
            Listen
          </Button>
        );
      }
      return null;
    }

    renderFullscreenButton = () => {
      const { contentType, userManager, contentMode } = this.props;
      if (contentType === CONTENT_ITEM_TYPES.CODEMONKEY_RESOURCE) {
        return (
          <Button className={(!userManager.canViewAsTeacher || (userManager.canViewAsTeacher && contentMode === CONTENT_MODE.TEACHER_PRESENT)) ? 'basic student white' : 'basic white'}
            onClick={() => this.handleFullscreen()} primary>Fullscreen
          </Button>
        );
      }
      return null;
    }

    renderDivider = () => {
      const { instruction } = this.props;
      if (instruction && instruction !== '<p></p>') {
        return (<div className='divider' />);
      }
      return null;
    }

    handleFullscreen = () => {
      const iframe = document.getElementById('myFrame');
      if (iframe) {
        if (iframe.requestFullscreen) {
          iframe.requestFullscreen();
        } else if (iframe.webkitRequestFullscreen) { // Chrome and Safari
          iframe.webkitRequestFullscreen();
        } else if (iframe.mozRequestFullScreen) { // FFox
          iframe.mozRequestFullScreen();
        } else if (iframe.msRequestFullscreen) { // IE
          iframe.msRequestFullscreen();
        }
      }
    }

    renderResourceUrl() {
      const {
        userManager, contentManager, contentMode, url, instruction, isFlowpaper, contentName,
        contentType, contentImageUrl, studentName, closeModalCallback, t
      } = this.props;
      const { currentContentItemId } = contentManager;
      const { addInfoOpen, confirmationOpen, contentUrl, currentInstance } = this.state;
      const { InfoModal } = this;
      const transformFn = UtilityService.reactHtmlParserTransform;
      const isScormResource = (contentType === CONTENT_ITEM_TYPES.SCORM_RESOURCE);
      // Use contentUrl from state if available (from navigation), otherwise use prop
      const displayUrl = contentUrl || url;
      // Use currentInstance for student name if available (navigation context)
      const displayStudentName = currentInstance
        ? ActivityInstanceUserNavigationService.formatActivityInstanceUserName(currentInstance)
        : studentName;
      const allowScoring = this.allowRenderScoreButton();

      const modalHeaderTitleText = (allowScoring || (userManager.canViewAsTeacher && contentMode === 'review'))
        ? `${t('gradebookLabel')}: ${stripHtmlTags(displayStudentName)}`
        : stripHtmlTags(contentName);

      return (
        <Modal
          className={classNames('f-player-modal', 'FileViewerModal', {
            'scorm-resource': isScormResource
          })}
          open
          size='fullscreen'>
          <div className='f-header'>
            <div className='modal-title-text' title={modalHeaderTitleText}>
              {
                (allowScoring || (userManager.canViewAsTeacher && contentMode === 'review')) ? (
                  <p>
                    {t('gradebookLabel', 'FileViewerModal translation missing.')}
                    :
                    {' '}
                    {ReactHtmlParser(displayStudentName, { transform: transformFn })}
                  </p>
                ) :
                  <p>{ReactHtmlParser(contentName, { transform: transformFn })}</p>
              }
            </div>
            <div className='modal-title-button'>
              {this.renderFullscreenButton()}
              {/* {this.renderDocReaderButton()} CF-4585 */}
              {this.renderStudentInstructionButton()}
              {this.renderDivider()}
              {this.renderScoreButton()}
              {this.renderPreviousStudentButton()}
              {this.renderNextStudentButton()}
              <Button
                className={classNames('file-viewer-close-btn', 'basic', 'white', {
                  student: !userManager.canViewAsTeacher
                    || (userManager.canViewAsTeacher && contentMode === CONTENT_MODE.TEACHER_PRESENT)
                })}
                onClick={() => this.justClose()}
                primary>
                {t('closeButtonLabel')}
              </Button>
              {this.renderSubmitButton()}
            </div>
          </div>
          {/* Utilize `--fullscreen-modal-header-nav-separator-display` style var to hide/show (`none`/`unset`) */}
          <div className='fullscreen-modal-nav-separator' />
          {/* remove allow if it works on index */}
          <div className={`f-content ${contentType === CONTENT_ITEM_TYPES.SCORM_RESOURCE ? 'scorm-content' : ''}`}>
            {(isFlowpaper || contentType === CONTENT_ITEM_TYPES.BOOKMARK_RESOURCE ||
            CONTENT_ITEM_TYPES.isExternalAppType(contentType)) && (
              <Iframe
                key={currentInstance?.id || 'default'}
                allow='microphone *'
                height='100%'
                id='myFrame'
                position='relative'
                title={UtilityService.stripHtmlTagsAndStrip(contentName)}
                url={displayUrl}
                width='100%' />
            )}
          </div>
          <InfoModal
            addInfoOpen={addInfoOpen}
            closeInfoModal={this.closeInfoModal}
            contentItemDescription={null}
            imageUrl={contentImageUrl}
            infoName={contentName}
            resourceInfo={null}
            studentInstruction={instruction} />
          <Confirm
            cancelButton={t('confirmCancelButton')}
            confirmButton={t('confirmConfirmButton')}
            content={t('confirmContent')}
            header={t('confirmHeader')}
            onCancel={() => this.setState({ confirmationOpen: false })}
            onConfirm={() => {
              this.submitAndClose();
              this.setState({ confirmationOpen: false });
            }}
            open={confirmationOpen} />
        </Modal>
      );
    }

    renderPdf() {
      const { userManager, contentMode, url, contentName, studentName, t, closeModalCallback } = this.props;
      const { contentUrl, currentInstance } = this.state;
      const { InfoModal } = this;
      // interface Props {
      //   url: string;
      //   containerId?: string;
      //   containerProps?: React.HTMLProps<HTMLDivElement>;
      //   width?: string;
      //   height?: string;
      //   page?: string | number;
      //   id?: string;
      //   fallbackLink?: string | false;
      // }
      const transformFn = UtilityService.reactHtmlParserTransform;
      // Use contentUrl from state if available (from navigation), otherwise use prop
      const displayUrl = contentUrl || url;
      // Use currentInstance for student name if available (navigation context)
      const displayStudentName = currentInstance
        ? ActivityInstanceUserNavigationService.formatActivityInstanceUserName(currentInstance)
        : studentName;
      const allowScoring = this.allowRenderScoreButton();

      const modalHeaderTitleText = (allowScoring || (userManager.canViewAsTeacher && contentMode === 'review'))
        ? `${t('gradebookLabel')}: ${stripHtmlTags(displayStudentName)}`
        : stripHtmlTags(contentName);

      return (
        <Modal
          className='f-player-modal FileViewerModal'
          onMount={() => document.body.classList.add('body-f-player-modal')}
          onUnmount={() => document.body.classList.remove('body-f-player-modal')}
          open
          size='fullscreen'>
          <div className='f-header'>
            <div className='modal-title-text' title={modalHeaderTitleText}>
              {
                (allowScoring || (userManager.canViewAsTeacher && contentMode === 'review')) ? (
                  <p>
                    {t('gradebookLabel', 'FileViewerModal translation missing.')}
                    :
                    {' '}
                    {ReactHtmlParser(displayStudentName, { transform: transformFn })}
                  </p>
                ) :
                  <p>{ReactHtmlParser(contentName, { transform: transformFn })}</p>
              }
            </div>
            <div className='modal-title-button'>
              {this.renderStudentInstructionButton()}
              {this.renderDivider()}
              {this.renderScoreButton()}
              {this.renderPreviousStudentButton()}
              {this.renderNextStudentButton()}
              {this.renderSubmitButton()}
              <Button
                className={classNames('file-viewer-close-btn', 'basic', 'white', {
                  student: !userManager.canViewAsTeacher
                    || (userManager.canViewAsTeacher && contentMode === CONTENT_MODE.TEACHER_PRESENT)
                })}
                onClick={() => closeModalCallback()}
                primary>
                {t('closeButtonLabel')}
              </Button>
            </div>
          </div>
          {/* Utilize `--fullscreen-modal-header-nav-separator-display` style var to hide/show (`none`/`unset`) */}
          <div className='fullscreen-modal-nav-separator' />
          <div className='f-content'>
            <PDFObject key={currentInstance?.id || 'default'} height='100%' url={displayUrl} />
          </div>
          <InfoModal
            addInfoOpen={this.state.addInfoOpen}
            closeInfoModal={this.closeInfoModal}
            contentItemDescription={null}
            imageUrl={this.props.contentImageUrl}
            infoName={contentName}
            resourceInfo={null}
            studentInstruction={this.props.instruction} />
          <Confirm
            cancelButton={t('confirmCancelButton')}
            confirmButton={t('confirmConfirmButton')}
            content={t('confirmContent')}
            header={t('confirmHeader')}
            onCancel={() => this.setState({ confirmationOpen: false })}
            onConfirm={() => {
              this.submitAndClose();
              this.setState({ confirmationOpen: false });
            }}
            open={this.state.confirmationOpen} />
        </Modal>
      );
    }

    render() {
      const { ScoreAssignmentModal, closeGradeAssignment } = this;
      const { assignmentId, contentType, grade, isFlowpaper, maxScore, studentName, totalScore } = this.props;
      const { currentInstance, showScoreModal } = this.state;

      // Use currentInstance if available (navigation context), otherwise use props
      const currentInstanceId = currentInstance?.id || assignmentId;
      const currentStudentName = currentInstance
        ? ActivityInstanceUserNavigationService.formatActivityInstanceUserName(currentInstance)
        : studentName;
      const currentGrade = currentInstance ? currentInstance.grade : grade;
      const currentTotalScore = currentInstance ? currentInstance.totalScore : totalScore;

      return (
        <>
          {(isFlowpaper || CONTENT_ITEM_TYPES.isExternalAppType(contentType) || contentType === CONTENT_ITEM_TYPES.BOOKMARK_RESOURCE) ?
            this.renderResourceUrl()
            :
            this.renderPdf()}
          {/* Using the modal directly as the dialogManager doesn't seem to work for modals within the lti iFrame */}
          <ScoreAssignmentModal
            key={currentInstanceId}
            activityInstanceId={currentInstanceId}
            allowScoreAssignmentModalInfoSessionStorage={false}
            closeGradeAssignment={closeGradeAssignment}
            grade={currentGrade || 0}
            gradeAssignmentOpen={showScoreModal}
            maxScore={maxScore || 100}
            studentName={currentStudentName}
            totalScore={currentTotalScore || 0} />
        </>
      );
    }
}
SatCoreRegister('FileViewerModal', FileViewerModal);
